import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../Config';
import { ContentsReturn } from '../Interfaces/ContentsReturn'

interface CommercialContents {
    helpContent: ContentsReturn;
    smallBusinessContent: ContentsReturn;
    largerBusinessContent: ContentsReturn;
}

const GUIDS = {
    help: '8fb0f356-a66d-46ab-95ca-847c1270ab1b',
    smallBusiness: 'fec00d92-7ae2-457e-b260-4296a50ae4cc',
    largerBusiness: '0e6b49c2-2ec8-43dd-b1bb-4fa9645c6840'
} as const;

const emptyContentsReturn: ContentsReturn = {
    id: '',
    page: '',
    heading: '',
    content: '',
    clientID: 0
};

const initialContents: CommercialContents = {
    helpContent: emptyContentsReturn,
    smallBusinessContent: emptyContentsReturn,
    largerBusinessContent: emptyContentsReturn
};

export const useCommercialContent = (): CommercialContents => {
    const [contents, setContents] = useState<CommercialContents>(initialContents);

    useEffect(() => {
        const fetchData = async (): Promise<void> => {
            try {
                const res = await axios.get<ContentsReturn[]>(`${config.apiUrl}/Contents/${config.tenant}/tenant/commercial`);
                const all = res.data;
                const getById = (id: string): ContentsReturn =>
                    all.find((item) => item.id === id) ?? emptyContentsReturn;

                setContents({
                    helpContent: getById(GUIDS.help),
                    smallBusinessContent: getById(GUIDS.smallBusiness),
                    largerBusinessContent: getById(GUIDS.largerBusiness)
                });
            } catch (error) {
                console.error('Error fetching home content:', error);
            }
        };
        fetchData();
    }, []);

    return contents;
};